module.exports = __webpack_public_path__ + "logo-black.03835376a7f959cb51e26140123fe89d.svg";